// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Agencies map
async function getAgenciesMap ($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesMap", webpackPrefetch: true */ './js/components/agenciesMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agencies Search Form
async function getAsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "customLists" */ './js/components/customLists.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html').animate({ scrollTop: $('#step-pagination').offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
    })
  })
}

// Offers Search Form
async function getOsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "offersSearchForm" */ './js/components/offersSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Autocomplete
async function getOffersAutocomplete ($f) {
  import(/* webpackChunkName: "offersAutocomplete" */ './js/components/offersAutocomplete.js').then(module => {
    module.offersAutocomplete.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion de la recherche d'agences la plus proche
  const $c1 = $('form[name="asForm"]')
  if ($c1.length) {
    $c1.waypoint(function () {
      getAsForm($c1)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des scrollbars améliorées
  const $c2 = $('.custom-lists')
  if ($c2.length) {
    $c2.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $c3 = $('form[name="cForm"]')
  if ($c3.length) {
    $c3.waypoint(function () {
      getCForm($c3)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $c4 = $('.pajinate')
  if ($c4.length) {
    $c4.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la recherche d'offres
  const $c5 = $('form[name="osForm"]')
  if ($c5.length) {
    $c5.waypoint(function () {
      getOsForm($c5)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des alertes BS
  const $c6 = $('.alert')
  if ($c6.length) {
    $c6.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })

  // filtres des offres autocomplete
  $('form[name="osForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getOffersAutocomplete($(this).parents('form'))
  })

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des agences
    const $c5 = $('#map-agencies').length ? $('#map-agencies') : $('#map-detail')
    if ($c5.length) {
      $c5.waypoint(function () {
        getAgenciesMap($c5)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })
})
